module.exports = __webpack_public_path__ + "img/telemedicine2.e51697b8.jpg";